var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("g-breadcrumb", {
        attrs: { paginas: _vm.paginaStatus.caminhoMigalha }
      }),
      _c("div", { staticClass: "q-card gvn-cabecalho" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-10 gvn-title-primary mrg-t-0" }, [
            _vm._v("Dados do requerente")
          ]),
          _c(
            "div",
            { staticClass: "col-sm-2 text-right" },
            [
              _vm.imprimir == true
                ? _c("q-tooltip", [_vm._v("Comprovante de encaminhamento")])
                : _vm._e(),
              _vm.imprimir == true
                ? _c(
                    "q-btn",
                    {
                      attrs: {
                        id: "imprimirComprovanteEncaminhamento",
                        name: "imprimirComprovanteEncaminhamento",
                        icon: "fa fa-print",
                        color: "primary",
                        flat: ""
                      },
                      on: { click: _vm.imprimirComprovanteEncaminhamento }
                    },
                    [_vm._v("  Imprimir\n        ")]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Tipo de Pessoa:: ")]),
            _vm._v(
              "\n        " +
                _vm._s(this.indTipoPessoa === "J" ? "Jurídica" : "Física") +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Nome: ")]),
            _vm._v(
              "\n        " +
                _vm._s(this.nomRequerente) +
                " - " +
                _vm._s(this.txtDocumento) +
                "\n      "
            )
          ]),
          _vm.indTipoPessoa !== "J"
            ? _c(
                "div",
                { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" },
                [
                  _c("strong", [_vm._v("Data de nascimento: ")]),
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        this.formatarData(this.dataNascimento, "dd/mm/yyyy")
                      ) +
                      "\n      "
                  )
                ]
              )
            : _vm._e()
        ]),
        _vm.indTipoPessoa !== "J"
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" },
                [
                  _c("strong", [_vm._v("Sexo: ")]),
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        this.indSexo === "M"
                          ? "Masculino"
                          : this.indSexo === "F"
                            ? "Feminino"
                            : this.indSexo === "I"
                              ? "Indiferente"
                              : ""
                      ) +
                      "\n      "
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" },
                [
                  _c("strong", [_vm._v("Estado Civil: ")]),
                  _vm._v(
                    "\n        " +
                      _vm._s(this.formataEstadoCivil(this.indEstadoCivil)) +
                      "\n      "
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" },
                [
                  _c("strong", [_vm._v("Nacionalidade: ")]),
                  _vm._v(
                    "\n        " + _vm._s(this.nomNacionalidade) + "\n      "
                  )
                ]
              )
            ])
          : _vm._e(),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("CEP: ")]),
            _vm._v("\n        " + _vm._s(this.numCEP) + "\n      ")
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Logradouro: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.protocoloSolicitacaoMovimentacao
                    .protocoloSolicitacao.requerente.logradouro.nomLogradouro
                ) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Número: ")]),
            _vm._v("\n        " + _vm._s(this.numNumero) + "\n      ")
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Complemento: ")]),
            _vm._v("\n        " + _vm._s(this.txtComplemento) + "\n      ")
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Bairro: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.protocoloSolicitacaoMovimentacao
                    .protocoloSolicitacao.requerente.bairro.nomBairro
                ) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Cidade: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.protocoloSolicitacaoMovimentacao
                    .protocoloSolicitacao.requerente.municipio.nomMunicipio
                ) +
                "\n      "
            )
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("UF: ")]),
            _vm._v("\n        " + _vm._s(this.desUf) + "\n      ")
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Telefone Móvel: ")]),
            _vm._v(
              "\n        " +
                _vm._s(this.numTelefoneMovelPortal || this.numTelefoneMovel) +
                "\n      "
            )
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Email: ")]),
            _vm._v(
              "\n        " +
                _vm._s(this.txtEmailPortal || this.txtEmail) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Telefone Residencial: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.numTelefoneResidencialPortal ||
                    this.numTelefoneResidencial
                ) +
                "\n      "
            )
          ])
        ])
      ]),
      _c("br"),
      _c(
        "g-gridview",
        {
          ref: "refSolicitacaoMovimentacaoDocumentos",
          attrs: {
            id: "refSolicitacaoMovimentacaoDocumentos",
            name: "refSolicitacaoMovimentacaoDocumentos",
            exibirEtiqueta: false,
            colunas: _vm.colunasSolicitacaoDocumentosDataTable,
            operacoes: _vm.operacoes,
            exibirBotaoVisualizacao: false,
            exibirBotaoEdicao: false,
            exibirBotaoExclusao: false,
            desabilitar: true,
            exibirColunaOperacoes: _vm.exibirColunaOperacoes,
            inicializarVazio: true
          }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 gvn-title-primary mrg-t-0" }, [
              _vm._v("Dados da solicitação")
            ])
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-3 col-xs-3 mrg-t-10" },
              [
                _c("g-input", {
                  ref: "refNumSolicitacao",
                  attrs: {
                    id: "refNumSolicitacao",
                    name: "refNumSolicitacao",
                    tipo: "text",
                    etiqueta: "Nº Solicitação",
                    validacao: "numeric",
                    foco: false,
                    desabilitar: true
                  },
                  model: {
                    value:
                      _vm.paginaStatus.protocoloSolicitacaoMovimentacao
                        .protocoloSolicitacao.numSolicitacao,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.paginaStatus.protocoloSolicitacaoMovimentacao
                          .protocoloSolicitacao,
                        "numSolicitacao",
                        $$v
                      )
                    },
                    expression:
                      "paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.numSolicitacao"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-3 col-xs-3" },
              [
                _c("g-datepicker", {
                  ref: "refDatSolicitacao",
                  attrs: {
                    id: "refDatSolicitacao",
                    name: "refDatSolicitacao",
                    etiqueta: "Data Solicitação",
                    desabilitar: true
                  },
                  model: {
                    value:
                      _vm.paginaStatus.protocoloSolicitacaoMovimentacao
                        .protocoloSolicitacao.datSolicitacao,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.paginaStatus.protocoloSolicitacaoMovimentacao
                          .protocoloSolicitacao,
                        "datSolicitacao",
                        $$v
                      )
                    },
                    expression:
                      "paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.datSolicitacao"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-5 col-xs-5 mrg-l-48 mrg-t-10" },
              [
                _c("g-autocomplete", {
                  ref: "refTipoProcesso",
                  attrs: {
                    id: "refTipoProcesso",
                    name: "refTipoProcesso",
                    etiqueta: "Tipo de Processo",
                    valor: "codTipoProcesso",
                    foco: false,
                    descricaoPrimaria: "desTipoProcesso",
                    api: _vm.apitipoProcesso,
                    desabilitar: _vm.desabilitarTipoProcesso
                  },
                  model: {
                    value: _vm.codTipoProcesso,
                    callback: function($$v) {
                      _vm.codTipoProcesso = $$v
                    },
                    expression: "codTipoProcesso"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-6 col-xs-6" },
              [
                _c("g-autocomplete", {
                  ref: "refAssunto",
                  attrs: {
                    id: "refAssunto",
                    name: "refAssunto",
                    etiqueta: "Assunto",
                    valor: "codAssunto",
                    descricaoPrimaria: "desAssunto",
                    foco: false,
                    api: _vm.apiAssunto,
                    desabilitar: _vm.desabilitarAssunto
                  },
                  model: {
                    value: _vm.codAssunto,
                    callback: function($$v) {
                      _vm.codAssunto = $$v
                    },
                    expression: "codAssunto"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-6 col-xs-6" },
              [
                _c("g-autocomplete", {
                  ref: "refSubAssunto",
                  attrs: {
                    id: "refSubAssunto",
                    name: "refSubAssunto",
                    etiqueta: "Subassunto",
                    valor: "codSubassunto",
                    descricaoPrimaria: "desSubassunto",
                    acaoPosSelecao: _vm.buscarDocumentoNecessario,
                    api: _vm.apiSubAssunto,
                    foco: false,
                    filtroAdicional: _vm.getFiltroSubassunto,
                    desabilitar:
                      _vm.codAssunto == null ||
                      _vm.codAssunto == "" ||
                      _vm.desabilitarSubAssunto
                  },
                  model: {
                    value: _vm.codSubassunto,
                    callback: function($$v) {
                      _vm.codSubassunto = $$v
                    },
                    expression: "codSubassunto"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 col-xs-12" },
              [
                _c("g-autocomplete", {
                  ref: "refJustificativa",
                  attrs: {
                    id: "refJustificativa",
                    name: "refJustificativa",
                    etiqueta: "Justificativa do Processo",
                    valor: "codJustificativa",
                    foco: false,
                    descricaoPrimaria: "desJustificativa",
                    desabilitar:
                      !_vm.codTipoProcesso ||
                      !_vm.codAssunto ||
                      !_vm.codSubassunto,
                    api: _vm.apiJustificativa,
                    filtroAdicional: _vm.getFiltroJustificativa
                  },
                  model: {
                    value:
                      _vm.paginaStatus.aberturaProcesso.justificativa
                        .codJustificativa,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.paginaStatus.aberturaProcesso.justificativa,
                        "codJustificativa",
                        $$v
                      )
                    },
                    expression:
                      "paginaStatus.aberturaProcesso.justificativa.codJustificativa"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 col-xs-12" },
              [
                _c("g-input", {
                  ref: "refJustificativaSolicitacao",
                  attrs: {
                    id: "refJustificativaSolicitacao",
                    name: "refJustificativaSolicitacao",
                    tipo: "textarea",
                    etiqueta: "Descrição",
                    validacao: "maxlength(1000)",
                    tamanho: 1000,
                    foco: false,
                    desabilitar: _vm.desabilitarObservacao
                  },
                  model: {
                    value: _vm.txtJustificativa,
                    callback: function($$v) {
                      _vm.txtJustificativa = $$v
                    },
                    expression: "txtJustificativa"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-12 col-xs-12" },
              [
                _c("g-input", {
                  ref: "refObservacaoSolicitacao",
                  attrs: {
                    id: "refObservacaoSolicitacao",
                    name: "refObservacaoSolicitacao",
                    tipo: "textarea",
                    etiqueta: "Observação da Solicitação",
                    validacao: "maxlength(250)",
                    tamanho: 250,
                    foco: false,
                    desabilitar: _vm.desabilitarObservacao
                  },
                  model: {
                    value: _vm.txtObservacao,
                    callback: function($$v) {
                      _vm.txtObservacao = $$v
                    },
                    expression: "txtObservacao"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 gvn-title-primary mrg-t-2" }, [
              _vm._v("Documentação Anexada")
            ])
          ])
        ]
      ),
      _c("div", { staticClass: "q-card gvn-cabecalho mrg-b-10" }, [
        _vm._m(0),
        _c("div", { staticClass: "row" }, [
          _c(
            "table",
            {
              staticClass: "col-md-12",
              attrs: { cellspacing: "0", cellpadding: "0" }
            },
            [
              _vm._m(1),
              _c(
                "tbody",
                _vm._l(_vm.dadosDocumentoNecessarioArray, function(doc) {
                  return _c("tr", { key: doc.a }, [
                    _c(
                      "td",
                      { staticClass: "text-left" },
                      [
                        _c("q-toggle", {
                          attrs: {
                            id: "toglleDesabilidarDocumentos",
                            name: "toglleDesabilidarDocumentos",
                            disable: _vm.desabilitarDocumentos,
                            color: "teal-8",
                            val: doc,
                            "true-value": "S",
                            "false-value": "N",
                            "checked-icon": "check",
                            "unchecked-icon": "clear"
                          },
                          model: {
                            value: _vm.documentoToggle,
                            callback: function($$v) {
                              _vm.documentoToggle = $$v
                            },
                            expression: "documentoToggle"
                          }
                        }),
                        _vm._v(
                          "\n                \n              " +
                            _vm._s(doc.documento.nomDocumento) +
                            "\n            "
                        )
                      ],
                      1
                    )
                  ])
                })
              )
            ]
          )
        ])
      ]),
      _c("div", { staticClass: "q-card gvn-cabecalho mrg-b-10" }, [
        _vm._m(2),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-sm-3 col-xs-3",
              staticStyle: { "padding-top": "10px" }
            },
            [
              _c("g-select", {
                ref: "refIndRetorno",
                attrs: {
                  id: "refIndRetorno",
                  name: "refIndRetorno",
                  etiqueta: "Retorno da Solicitação",
                  itens: _vm.retornoArray,
                  "item-valor": "indRetorno",
                  "item-etiqueta": "descricao",
                  foco: false,
                  desabilitar: _vm.desabilitarRetorno
                },
                model: {
                  value: _vm.indRetorno,
                  callback: function($$v) {
                    _vm.indRetorno = $$v
                  },
                  expression: "indRetorno"
                }
              })
            ],
            1
          )
        ]),
        _c("br"),
        _c("div", { staticClass: "row" }, [
          _vm.indRetorno === "PDC" || _vm.indRetorno === "REJ"
            ? _c(
                "div",
                { staticClass: "col-sm-12 col-xs-12" },
                [
                  _c("q-editor", {
                    attrs: {
                      id: "editortxtObservacaoRetorno",
                      name: "editortxtObservacaoRetorno",
                      readonly: _vm.readonly,
                      disable: _vm.desabilitarObservacaoRetorno,
                      toolbar: [
                        [
                          "bold",
                          "italic",
                          "strike",
                          "underline",
                          "subscript",
                          "superscript"
                        ],
                        ["token", "hr", "link", "custom_btn"],
                        ["fullscreen"],
                        [
                          {
                            label: _vm.$q.i18n.editor.formatting,
                            icon: _vm.$q.icon.editor.formatting,
                            list: "no-icons",
                            options: [
                              "p",
                              "h1",
                              "h2",
                              "h3",
                              "h4",
                              "h5",
                              "h6",
                              "code"
                            ]
                          },
                          {
                            label: _vm.$q.i18n.editor.fontSize,
                            icon: _vm.$q.icon.editor.fontSize,
                            fixedLabel: true,
                            fixedIcon: true,
                            list: "no-icons",
                            options: [
                              "size-1",
                              "size-2",
                              "size-3",
                              "size-4",
                              "size-5",
                              "size-6",
                              "size-7"
                            ]
                          },
                          {
                            label: _vm.$q.i18n.editor.defaultFont,
                            icon: _vm.$q.icon.editor.font,
                            fixedIcon: true,
                            list: "no-icons",
                            options: [
                              "default_font",
                              "arial",
                              "arial_black",
                              "comic_sans",
                              "courier_new",
                              "impact",
                              "lucida_grande",
                              "times_new_roman",
                              "verdana"
                            ]
                          },
                          "removeFormat"
                        ],
                        ["quote", "unordered", "ordered", "outdent", "indent"],
                        [
                          {
                            label: _vm.$q.i18n.editor.align,
                            icon: _vm.$q.icon.editor.align,
                            fixedLabel: true,
                            list: "only-icons",
                            options: ["left", "center", "right", "justify"]
                          }
                        ],
                        ["undo", "redo"]
                      ],
                      fonts: {
                        arial: "Arial",
                        arial_black: "Arial Black",
                        comic_sans: "Comic Sans MS",
                        courier_new: "Courier New",
                        impact: "Impact",
                        lucida_grande: "Lucida Grande",
                        times_new_roman: "Times New Roman",
                        verdana: "Verdana"
                      }
                    },
                    model: {
                      value: _vm.txtObservacaoRetorno,
                      callback: function($$v) {
                        _vm.txtObservacaoRetorno = $$v
                      },
                      expression: "txtObservacaoRetorno"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-12 text-right pad-20t-h10-80b" },
        [
          _c(
            "q-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visualizarSalvar,
                  expression: "visualizarSalvar"
                }
              ],
              staticClass: "fixed",
              staticStyle: { right: "18px", bottom: "18px" },
              attrs: {
                round: "",
                id: "btnSalvar",
                name: "btnSalvar",
                color: "positive",
                icon: "check",
                size: "lg"
              },
              on: { click: _vm.salvar }
            },
            [_c("q-tooltip", [_vm._v("Salvar")])],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 gvn-title-primary mrg-t-2" }, [
        _vm._v("Documentação Necessária")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-left", attrs: { width: "50%" } }, [
          _vm._v("Documentação Necessária Entregue")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 gvn-title-primary mrg-t-2" }, [
        _vm._v("Retorno da Solicitação")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }